import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// Label on the left, bold value on the right.
@Component({
  selector: 'lib-card-row',
  templateUrl: './card-row.html',
  styleUrl: './card-row.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardRowComponent {
  label = input.required<string>();
  value = input<string | number | null | undefined>('');
}
